import { motion } from 'framer-motion';
import RunawayButton from '../components/RunawayButton';
import '../styles/templates.css';

const FloatingHearts = () => (
  <div className="floating-hearts">
    {[...Array(15)].map((_, i) => (
      <motion.div
        key={i}
        className="heart"
        initial={{ y: '100vh', x: `${Math.random() * 100}vw`, opacity: 0 }}
        animate={{
          y: '-10vh',
          opacity: [0, 1, 1, 0],
        }}
        transition={{
          duration: 4 + Math.random() * 3,
          repeat: Infinity,
          delay: Math.random() * 5,
          ease: 'linear',
        }}
      >
        {'\uD83D\uDC95'}
      </motion.div>
    ))}
  </div>
);

const ValentineTemplate = ({ question, onYes, showCta, cta, patternStyle = {} }) => {
  if (showCta) {
    return (
      <motion.div
        className="template valentine-template cta-view"
        initial={{ rotateY: 90 }}
        animate={{ rotateY: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="pattern-overlay" style={patternStyle} />
        <FloatingHearts />
        <div className="cta-content">
          <motion.div
            className="success-icon"
            animate={{ scale: [1, 1.2, 1] }}
            transition={{ duration: 0.5, repeat: Infinity, repeatDelay: 1 }}
          >
            {'\uD83D\uDC96'}
          </motion.div>
          <h1>Yay! You said YES!</h1>
          <p className="cta-text">{cta}</p>
          <motion.div
            className="confetti"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {'\uD83C\uDF89\u2728\uD83D\uDC9D\u2728\uD83C\uDF89'}
          </motion.div>
        </div>
      </motion.div>
    );
  }

  return (
    <div className="template valentine-template">
      <div className="pattern-overlay" style={patternStyle} />
      <FloatingHearts />
      <div className="template-content">
        <motion.h1
          className="invite-question"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          {question}
        </motion.h1>

        <div className="button-container">
          <motion.button
            className="yes-button"
            onClick={onYes}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            Yes! {'\uD83D\uDC95'}
          </motion.button>
        </div>
      </div>

      <RunawayButton className="valentine-no">
        No {'\uD83D\uDC94'}
      </RunawayButton>
    </div>
  );
};

export default ValentineTemplate;
